import { IDialogAction } from './IDialogAction';
import { DialogState } from '../models/DialogState';

export const PREINITIALIZE = 'PREINITIALIZE';

export class PreinitializeAction implements IDialogAction {
    public readonly type = PREINITIALIZE;
    public constructor(public payload: any) {}
    public reducer(state: DialogState): DialogState {
        state.feed.ready = false;
        state.feed.messagesReady = false;
        state.feed.messages = [];
        state.feed.tabs = [];
        state.feed.currentUser = this.payload.claim;
        return state;
    }
}

export const PreinitializeActionTypeMapping = {
    [PREINITIALIZE]: PreinitializeAction
};